import {action} from 'mobx'
import {notification} from 'antd'
import {List as ListBasic} from 'Store/_shared/list'

export class List extends ListBasic {
  constructor(rootStore, api) {
    super(api, 'backtest')
    this.root = rootStore
  }
  @action async deleteSelected() {
    this.loading = true
    try {
      await this.api.request('sys/algos/delete', 'post', {ids: this.selected})
      this.load()
      this.root.algo.list.load()
    } catch (e) {
      notification['error']({
        message: 'Failed to delete algos',
        description: e.message || 'Unknown error'
      })
      this.loading = false
    }
  }
}
